/**
 * Takeaway preparation status constants - mirrors ReservationTakeAwayInfo status constants from backend.
 *
 * These represent the internal WeWelcom takeaway workflow statuses:
 * PENDING → PREPARING → REVIEW → READY_FOR_PICKUP → PICKED_UP
 */
export const TAKEAWAY_STATUS = {
	PENDING: 0,
	PREPARING: 2,
	REVIEW: 3,
	READY_FOR_PICKUP: 4,
	PICKED_UP: 5,
	CANCELLED: -1,
};

export const TAKEAWAY_STATUS_LABELS = {
	[TAKEAWAY_STATUS.PENDING]: 'Pendiente',
	[TAKEAWAY_STATUS.PREPARING]: 'Preparando',
	[TAKEAWAY_STATUS.REVIEW]: 'Revisión',
	[TAKEAWAY_STATUS.READY_FOR_PICKUP]: 'Listo para recoger',
	[TAKEAWAY_STATUS.PICKED_UP]: 'Recogido',
	[TAKEAWAY_STATUS.CANCELLED]: 'Cancelado',
};
